import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { Routes, RouterModule } from '@angular/router';

import { IonicModule } from '@ionic/angular';

import { AddLearnerModalPage } from './add-learner-modal.page';

const routes: Routes = [
  {
    path: '',
    component: AddLearnerModalPage
  }
];

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    RouterModule.forChild(routes)
  ],
  declarations: [AddLearnerModalPage]
})
export class AddLearnerModalPageModule {}
